import IMask from 'imask'
import { getCurrencySymbolByCode, getCurrencySymbolById } from 'services/utils'

export const moneyMask = IMask.createMask({
  mask: Number,
  radix: ',',
  thousandsSeparator: ' ',
  signed: true
})

export const getCurrencySymbol = (currencyCode, currencyId) => {
  if (currencyCode) {
    return getCurrencySymbolByCode(currencyCode)
  }
  if (currencyId) {
    return getCurrencySymbolById(currencyId)
  }
  return null
}
